import ExportInventoryModalContainer from './export-inventory-modal-container';

export default ExportInventoryModalContainer;
